/* unplugin-vue-components disabled */import { render } from "./Content.vue?vue&type=template&id=4731c0e9&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import "./Content.vue?vue&type=style&index=0&id=4731c0e9&lang=scss&scoped=true"

import exportComponent from "/data/repos/231_20260324134036/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4731c0e9"]])

export default __exports__